import { WS_METHODS } from "@afar-research/contracts";
import { Atom } from "effect/unstable/reactivity";

import {
  createAtomCommandScheduler,
  createEnvironmentRpcCommand,
  createEnvironmentRpcQueryAtomFamily,
} from "./runtime.ts";
import type { EnvironmentRegistry } from "../connection/registry.ts";
import { vcsCommandConcurrency, vcsCommandScheduler } from "./vcsCommandScheduler.ts";

export function createSourceControlEnvironmentAtoms<R, E>(
  runtime: Atom.AtomRuntime<EnvironmentRegistry | R, E>,
) {
  const commandScheduler = createAtomCommandScheduler();
  return {
    discovery: createEnvironmentRpcQueryAtomFamily(runtime, {
      label: "environment-data:server:source-control-discovery",
      tag: WS_METHODS.serverDiscoverSourceControl,
    }),
    gitHubAuthenticationStatus: createEnvironmentRpcQueryAtomFamily(runtime, {
      label: "environment-data:source-control:github-authentication-status",
      tag: WS_METHODS.serverGitHubAuthenticationStatus,
    }),
    startGitHubAuthentication: createEnvironmentRpcCommand(runtime, {
      label: "environment-data:source-control:github-authentication-start",
      tag: WS_METHODS.serverGitHubAuthenticationStart,
      scheduler: commandScheduler,
      concurrency: { mode: "serial", key: ({ environmentId }) => environmentId },
    }),
    cancelGitHubAuthentication: createEnvironmentRpcCommand(runtime, {
      label: "environment-data:source-control:github-authentication-cancel",
      tag: WS_METHODS.serverGitHubAuthenticationCancel,
      scheduler: commandScheduler,
      concurrency: { mode: "serial", key: ({ environmentId }) => environmentId },
    }),
    disconnectGitHub: createEnvironmentRpcCommand(runtime, {
      label: "environment-data:source-control:github-authentication-disconnect",
      tag: WS_METHODS.serverGitHubAuthenticationDisconnect,
      scheduler: commandScheduler,
      concurrency: { mode: "serial", key: ({ environmentId }) => environmentId },
    }),
    repository: createEnvironmentRpcQueryAtomFamily(runtime, {
      label: "environment-data:source-control:repository",
      tag: WS_METHODS.sourceControlLookupRepository,
    }),
    cloneRepository: createEnvironmentRpcCommand(runtime, {
      label: "environment-data:source-control:clone-repository",
      tag: WS_METHODS.sourceControlCloneRepository,
      scheduler: commandScheduler,
      concurrency: {
        mode: "serial",
        key: ({ environmentId }) => environmentId,
      },
    }),
    publishRepository: createEnvironmentRpcCommand(runtime, {
      label: "environment-data:source-control:publish-repository",
      tag: WS_METHODS.sourceControlPublishRepository,
      scheduler: vcsCommandScheduler,
      concurrency: vcsCommandConcurrency,
    }),
  };
}
